import {
  CreatableSelect,
  GroupBase,
  Select as ChakraSelect,
  SelectInstance,
} from 'chakra-react-select';
import { ForwardedRef } from 'react';

import { fixedForwardRef } from '../../utils/fixed-forwardRef';
import {
  AsyncCreatableSelect,
  AsyncCreatableSelectProps as SelectProps,
  AsyncSelect,
} from './async-select';
import { PatchedSelectProps, patchSelect } from './patched-select';
import { getSelectStyles } from './select-styles';
import { isAsyncSelectProps, isCreatableSelectProps } from './utils';

export type { SelectProps };

function SelectWrapper<
  TOption,
  IsMulti extends boolean = false,
  TGroup extends GroupBase<TOption> = GroupBase<TOption>,
>(
  props: PatchedSelectProps<SelectProps<TOption, IsMulti, TGroup>>,
  ref: ForwardedRef<SelectInstance<TOption, IsMulti, TGroup>>,
) {
  const chakraStyles = getSelectStyles<TOption, IsMulti, TGroup>();

  if (isAsyncSelectProps(props)) {
    if (isCreatableSelectProps(props)) {
      return <AsyncCreatableSelect chakraStyles={chakraStyles} {...props} ref={ref} />;
    }

    return <AsyncSelect chakraStyles={chakraStyles} {...props} ref={ref} />;
  }

  if (isCreatableSelectProps(props)) {
    return <CreatableSelect chakraStyles={chakraStyles} {...props} ref={ref} />;
  }

  return <ChakraSelect chakraStyles={chakraStyles} {...props} ref={ref} />;
}

export const Select = patchSelect(fixedForwardRef(SelectWrapper));
